<template>
    <div>
        <b-row>
            <b-col cols="6" sm="1"
                class="d-flex justify-content-start justify-content-sm-center align-items-center order-1 order-sm-0">
                <!-- First button to the left. Previous -->
                <WhiteIconButton
                    icon="chevron-left"
                    emit-this="show-prev"
                    v-on:show-prev="showPrev"
                ></WhiteIconButton>
            </b-col>
            <b-col cols="12" sm="10" class="d-sm-block order-0 order-sm-1">
                <p class="img-label">{{currentImgDate}}</p>
                <VueSlickCarousel
                    :arrows="false"
                    ref="first"
                    :asNavFor="$refs.second"
                    :focusOnSelect="true"
                    @beforeChange="syncSliders"
                    @afterChange="afterChange"
                    :speed="0"
                >
                    <div class="text-center"
                        v-for="(url, index) in images"
                        :key="`first-${index}`"
                    >
                        <b-img
                            :src="url"
                            :fluid="true"
                            :alt="$t('sensors-page.camera-modal.dam-photo')"
                            :key="`first-img-${index}`"
                            @click="toggleModal(url)"
                        ></b-img>
                    </div>
                </VueSlickCarousel>
            </b-col>
            <b-col cols="6" sm="1"
                class="d-flex justify-content-end justify-content-sm-center align-items-center order-2 order-sm-2">
                <!-- Second button to the right of the carousel. Next -->
                <WhiteIconButton
                    icon="chevron-right"
                    emit-this="show-next"
                    v-on:show-next="showNext"
                ></WhiteIconButton>
            </b-col>

            <b-col cols="10" class="d-none d-sm-block mx-auto order-3">
                <VueSlickCarousel
                    ref="second"
                    :asNavFor="$refs.first"
                    :slidesToShow="4"
                    :focusOnSelect="true"
                    class="mt-3"
                    @beforeChange="syncSliders"
                >
                    <div class="bg-white text-center"
                        v-for="(url, index) in images"
                        :key="`second-${index}`"
                    >
                        <b-img
                            class="m-1"
                            :fluid="true"
                            :src="url"
                            :key="`second-img-${index}`"
                            :alt="$t('sensors-page.camera-modal.dam-photo')"></b-img>
                    </div>
                </VueSlickCarousel>
            </b-col>
        </b-row>
        <span class="date-label">{{currentImgDate}}</span>
    </div>

</template>

<script>
    // vuex
    import { mapActions} from "vuex";
    import { TOGGLE_ZOOM_MODAL, SET_IMAGE_SRC } from "../../store/actions/profile";
    // external
    import VueSlickCarousel from 'vue-slick-carousel'
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    // optional style for arrows & dots
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    // components
    import WhiteIconButton from "./WhiteIconButton";

    /**
     * Carousel gallery wrapper - shows two sets of carousels.
     * Top is one per show, large. Second is a set of 4 or as much
     * as they come.
     * Both carousels are synced. A semi-hack is used for the sync.
     */

    export default {
        name: 'CarouselGalleryWrapper',
        components: {
            VueSlickCarousel,
            WhiteIconButton
        },
        props: {
            images: {
                type: Array,
                required: true
            },
        },
        data() {
            return {
                currentImage: this.images[0],
                currentImgDate: null
            }
        },
        mounted() {
            this.currentImgDateFormatter(this.currentImage);
        },
        methods: {
            ...mapActions([TOGGLE_ZOOM_MODAL, SET_IMAGE_SRC]),
            /**
             * Used by the custom button to slide left
             */
            showPrev() {
                this.$refs.first.prev();
            },
            /**
             * Used by the custom button to slide right
             */
            showNext() {
                this.$refs.first.next();
            },
            /**
             * On a custom event emitted, handle it by
             * making the actual switch.
             * @param currentPosition
             * @param nextPosition
             */
            syncSliders(currentPosition, nextPosition) {
                this.$refs.first.goTo(nextPosition);
                this.$refs.second.goTo(nextPosition);
            },
            afterChange(currentIndex) {
                this.currentImage = this.images[currentIndex];
            },
            toggleModal(src) {
                this.SET_IMAGE_SRC(src);
                this.TOGGLE_ZOOM_MODAL();
            },
            currentImgDateFormatter(image) {
                if (image) {
                    let url = image.split('/');
                    let {[url.length - 1]: name} = url;
                    const reg = /picture_|.png|.jpeg/gi;
                    name = name.replace(reg, '');
                    name = name.replace('_', ' ');

                    return this.currentImgDate = name;
                }

                return  this.currentImgDate = "";
            }
        },
        watch: {
            currentImage(image) {
                this.currentImgDateFormatter(image);
            },
            images(newImages) {
                this.currentImage = newImages[0];
                this.currentImgDateFormatter(this.currentImage);
            }
        }
    }
</script>
<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .img-label {
        position: absolute;
        top: $cam-modal-img-label-top;
        right: $cam-modal-img-label-right;
        z-index: $cam-modal-img-label-z-index;
        font-size: $cam-modal-img-label-font-size;
        color: $cam-modal-img-label-color;
        background-color: $cam-modal-img-label-bg-color;
        padding: $cam-modal-img-label-padding;
        border-radius: $cam-modal-img-label-radius;
        opacity: $cam-modal-img-label-opacity;
    }
    .date-label {
        margin-right: auto;
        width: 100%;
        text-align: center;
        display: inline-block;
    }
</style>